export default __webpack_public_path__ + "static/media/942.337afe0d.png";